export const languageConstants = ["pl", "en", "uk", "de", "es", "fr"];
export const languageNameConstants = {
  pl: "Polski",
  en: "English",
  de: "Deutsch",
  es: "Español",
  uk: "Українська",
  fr: "French"
};
